import { Component, Input } from '@angular/core';
import { ITabLink } from '@shared/interfaces/ITabLink';

@Component({
  selector: 'app-routing-tabs',
  templateUrl: './routing-tabs.component.html',
  styleUrls: ['./routing-tabs.component.sass'],
})
export class RoutingTabsComponent {
  @Input() links: ITabLink[] = [];
}
